<template>
  <div class="card-content">
    <div>
      <b-checkbox class="mgb-30px" v-model="showArchive">
        {{ $t('archiverContact.showArchive', { nombre: archiveContactsNumber}) }}
      </b-checkbox>
      <contact-card
        class="mgb-20px"
        :key="contact.id"
        v-for="contact in filteredContacts"
        :contact="contact"
        @edit="modifierContact"
        @archive="archiverContact"
        @remove="removeContact"
        :isFromBailleur="isFromBailleur">
      </contact-card>
      <div v-if="!tier.lienUtilisateurId">
        <a class="button is-primary"
          :class="{ 'button-access-no-permission' : !checkPermissions(permsTiers.maj) }"
          @click="checkPermissions(permsTiers.maj) ? ajouterContact() : showPopUp()">
          {{ $t('editionClient.actions.addContact')}}
        </a>
      </div>
      <div v-else>
        <b-tooltip
          class="mr-2"
          position= "is-right"
          :label="$i18n.t('detailFournisseur.tooltipAjouterContact')">
          <a class="button is-primary"
            :class="{ 'button-access-no-permission' : !checkPermissions(permsTiers.maj) }"
            disabled>
            {{ $t('editionClient.actions.addContact')}}
          </a>
        </b-tooltip>
      </div>
    </div>
    <b-modal v-model="ajouterContactSelectionne"
        has-modal-card
        class="modal">
      <ajouter-contact
        :contact="contact"
        :contacts="tier.contacts"
        :isEditContact="isEditContact"
        :tiers="tier"
        :idTiers="tier.id"
        :isFromBailleur="isFromBailleur"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { TIERS } from '@/configuration/permissionsBodacConf';
import contactCard from '@/components/tiers/contacts/contactCard';
import AjouterContact from '@/components/clients/clients/editionClient/ajouterContact';
import contactGenerer from '@/services/tiers/genererContact';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'TierDetailContact',
  props: {
    tier: {
      type: Object,
      required: true,
    },
    isFromBailleur: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      permsTiers: TIERS,
      contact: null,
      isEditContact: false,
      ajouterContactSelectionne: false,
      messagesPopup: [],
      isErrorPopup: false,
      showArchive: false,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    filteredContacts() {
      if (this.showArchive) return this.tier.contacts;
      return this.tier.contacts.filter(c => !c.archive);
    },
    archiveContactsNumber() {
      return this.tier.contacts.filter(c => c.archive).length;
    },
  },
  components: {
    AjouterContact,
    contactCard,
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    modifierContact(contact) {
      this.contact = contact;
      this.isEditContact = true;
      this.ajouterContactSelectionne = true;
    },
    ajouterContact() {
      this.contact = contactGenerer();
      this.isEditContact = false;
      this.ajouterContactSelectionne = true;
    },
    archiverContact(id) {
      this.tier.contacts.forEach(contact => {
        if (contact.id === id) contact.archive = !contact.archive;
      });
    },
    removeContact(id) {
      const index = this.tier.contacts.findIndex(c => c.id === id);
      if (index >= 0) this.tier.contacts.splice(index, 1);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.civilite]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
